import Input, { SeturInputProps } from '@components/Input';

const PersonName = (props: SeturInputProps) => (
  <Input
    {...props}
    onKeyDown={(e) => {
      const isLetterOrTurkishChar = e.key.match(/[a-zA-ZÇĞİÖŞÜçğıöşü]/);
      const isSpace = e.key === ' ';
      const isControlKey = [
        'Backspace',
        'Delete',
        'ArrowLeft',
        'ArrowRight',
      ].includes(e.key);

      if (
        !isLetterOrTurkishChar &&
        !isSpace && // Allow space
        !isControlKey
      ) {
        e.preventDefault();
      }
    }}
  />
);

export default PersonName;
